import { useState, useRef, useEffect, createPortal } from "@wordpress/element";

export default function Label({
    label,
    help,
    containerClass = "",
    labelClass = "block text-sm font-medium text-gray-700",
    labelMargin = "",
}) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);

    useEffect(() => {
        if (showTooltip && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const tooltipWidth = 384; // 96 * 4 (w-96)

            setTooltipPosition({
                top: rect.top - 8, // 8px gap above
                left: rect.left + rect.width / 2 - tooltipWidth / 2,
            });
        }
    }, [showTooltip]);

    // Get the portal container
    const portalContainer = document.querySelector(".wpb-pmqb-app-wrapper");

    return (
        label && (
            <div
                className={`${
                    help ? "flex items-center gap-2" : ""
                } ${labelMargin} ${containerClass}`}
            >
                <h3 className={labelClass}>{label}</h3>
                {help && (
                    <>
                        <div
                            ref={triggerRef}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                            className="relative inline-block"
                        >
                            <span className="flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-help rounded-2xl bg-gray-200 w-4 h-4 text-xs">
                                ?
                            </span>
                        </div>

                        {showTooltip &&
                            createPortal(
                                <div
                                    className="fixed bg-gray-800 text-white text-xs rounded p-3 w-96 z-[9999999] pointer-events-none transform -translate-y-full shadow-lg"
                                    style={{
                                        top: `${tooltipPosition.top}px`,
                                        left: `${tooltipPosition.left}px`,
                                    }}
                                >
                                    {help}
                                    {/* Arrow pointing down */}
                                    <div className="absolute left-1/2 transform -translate-x-1/2 top-full w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-gray-800"></div>
                                </div>,
                                portalContainer
                            )}
                    </>
                )}
            </div>
        )
    );
}
